import React from "react";
import { Section1 } from "../Section1/Section1";
import { Section2 } from "../Section2/Section2";
import { Section4 } from "../Section4/Section4";
import { Footer } from "../../../components/Footer/Footer";
import { Navbar } from "../../../components/Navbar/Navbar";
import "./MainPage.css";


export const MainPage = () => {
  return (
    <>
      {/* 네비게이션 바는 고정되어 있음 */}
      <Navbar />

      {/* ✅ 섹션들을 감싸는 래퍼(Wrapper) 추가 */}
      <main className="main-wrapper">
        <Section1 />
        <Section2 />
        <Section4 />
      </main>

      <Footer />
    </>
  );
}


